export { default as Hate } from './hate.svg'
export { default as Skip } from './skip.svg'
export { default as Like } from './thumbs-up.svg'
export { default as Love } from './love.svg'
